import React from "react";
import FulfilledList from "../../components/fullfillment/fullfillmentList";

export const Completed = () => {
  return (
<FulfilledList status={'completed,Invalid'} listTitle='PROCESSED MAIL'/>
  );
};

export default Completed;